<template>
  <div class="content-container">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="管理员">
        <el-input
          v-model="formInline.username"
          placeholder="请输入管理员名"
        ></el-input>
      </el-form-item>

      <el-form-item label="业务类型">
        <el-select v-model="formInline.businessType" placeholder="请选择">
          <el-option
            v-for="(item, index) in BUSSINESS_TYPE_ENUM"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="日志时间">
        <el-date-picker
          v-model="formInline.createtime"
          type="daterange"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSearch"
          >查询</el-button
        >
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        prop="username"
        label="管理员"
        width="120"
      ></el-table-column>
      <el-table-column prop="businessType" label="业务类型" width="160">
        <template slot-scope="scope">
          <div>
            {{ $getLabelByValue(scope.row.businessType, BUSSINESS_TYPE_ENUM) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="detail"
        label="详情"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column label="创建时间" width="240">
        <template slot-scope="scope">
          <div>{{ scope.row.createtime | formatDateTime }}</div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    ></el-pagination>
  </div>
</template>

<script>
import enumObject from "../../plugins/enum";

export default {
  data() {
    return {
      formInline: {
        username: "",
        businessType: ""
      },
      tableData: [],

      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      BUSSINESS_TYPE_ENUM: enumObject.BUSSINESS_TYPE_ENUM
    };
  },

  methods: {
    onSearch() {
      let queryModel = {
        businessType: this.formInline.businessType,
        username: this.formInline.username,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,

        createtimeFrom: Array.isArray(this.formInline.createtime)
          ? this.$ToDateTimeString(this.formInline.createtime[0])
          : null,
        createtimeTo: Array.isArray(this.formInline.createtime)
          ? this.$ToDateTimeString(this.formInline.createtime[1])
          : null
      };

      this.$axios(this.$urlMapping["查询日志"], {
        data: queryModel
      }).then(result => {
        this.tableData = result.data;
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSearch();
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  },
  mounted() {
    this.onSearch();
  }
};
</script>

<style lang="less" scoped></style>

<style>
.el-tooltip__popper {
  max-width: 50%;
  font-size: 14px;
  line-height: 24px;
}
</style>
